<section class="confirmacao" aria-labelledby="confirmacao-titulo">
  <div class="confirmacao-cartao">
    <span class="confirmacao-selo" aria-hidden="true">
      <i-lucide name="circle-check-big" size="34"></i-lucide>
    </span>

    <h2 class="confirmacao-titulo" id="confirmacao-titulo">Pedido enviado com sucesso!</h2>

    <p class="confirmacao-texto">
      {{ saudacao() }} sua solicitação foi registrada no Serviço de Informação ao Cidadão
      {{ orgaoTexto() }}.
    </p>

    <div class="confirmacao-protocolo">
      <div class="confirmacao-protocolo-topo">
        <span class="confirmacao-protocolo-rotulo">Protocolo de atendimento</span>
        <span class="confirmacao-protocolo-situacao">{{ resultado()?.statusDescricao }}</span>
      </div>

      <strong class="confirmacao-protocolo-numero">{{ protocolo() }}</strong>

      <dl class="confirmacao-protocolo-detalhes">
        <div class="confirmacao-protocolo-linha">
          <dt>Data de abertura:</dt>
          <dd>{{ dataAbertura() }}</dd>
        </div>

        <div class="confirmacao-protocolo-linha">
          <dt>Prazo de resposta:</dt>
          <dd>{{ prazoTexto() }}</dd>
        </div>

        <div class="confirmacao-protocolo-linha">
          <dt>Departamento responsável:</dt>
          <dd>{{ departamentoResponsavel() }}</dd>
        </div>
      </dl>
    </div>

    <p class="confirmacao-texto">
      Com esse protocolo você pode acompanhar o andamento do pedido pelos canais do portal: aba
      "Acompanhamento de solicitação", central telefônica ou atendimento presencial no SIC.
    </p>

    @if (anonimo()) {
      <p class="confirmacao-texto">
        Como o pedido foi aberto de forma anônima, não há nome nem e-mail vinculados a ele: guarde o
        número do protocolo, que é a única forma de consultar a resposta.
      </p>
    } @else if (store.dadosPedido().receberAvisos) {
      <p class="confirmacao-texto">
        Os comunicados sobre o andamento do seu pedido serão enviados para o e-mail do seu cadastro.
      </p>
    }

    <p class="confirmacao-texto">Agradecemos o seu contato.</p>
  </div>

  <div class="confirmacao-acoes">
    <button type="button" class="confirmacao-botao confirmacao-botao-primario" (click)="salvarPdf()">
      <i-lucide name="download" size="16" aria-hidden="true"></i-lucide>
      Baixar comprovante PDF
    </button>

    <button type="button" class="confirmacao-botao" (click)="novoPedido.emit()">
      <i-lucide name="rotate-ccw" size="16" aria-hidden="true"></i-lucide>
      Abrir novo pedido e-SIC
    </button>
  </div>

  @if (!anonimo() && store.dadosPedido().receberAvisos) {
    <div class="confirmacao-alerta" role="status">
      <span class="confirmacao-alerta-icone" aria-hidden="true">
        <i-lucide name="mail" size="18"></i-lucide>
      </span>

      <div>
        <p class="confirmacao-alerta-titulo">Avisos por e-mail</p>
        <p class="confirmacao-alerta-texto">
          Você pediu para receber os andamentos por e-mail. Verifique a caixa de entrada (e a pasta
          Spam/Lixo Eletrônico) do endereço informado para acompanhar as atualizações do protocolo.
        </p>
      </div>
    </div>
  }
</section>
